/**
 * Normalizes Learning Center links returned by PortalApi for UI rendering.
 *
 * @param {{ learningCenterLinks?: Array<{ branchId?: string, label?: string, url?: string }> } | undefined} response
 * @returns {{ branchId?: string, label: string, url: string }[]}
 */
export function normalizeLearningCenterLinks(response) {
	const links = response?.learningCenterLinks;
	if (!Array.isArray(links)) {
		return [];
	}

	return links
		.filter((link) => link?.label && link?.url)
		.map((link) => ({
			branchId: link.branchId,
			label: link.label,
			url: String(link.url).trim(),
		}));
}

/**
 * @param {{ branchId?: string, label: string, url: string }[]} links
 */
export function hasLearningCenterLinks(links) {
	return Array.isArray(links) && links.length > 0;
}
